import './search-result.scss';

class SearchForm {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-searchform',
            fieldAttr: 'data-input'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$search = element;

        if (this.$search.querySelector('form') === null) {
            console.error('no form found');
        }
    }

    initialize () {
        this.initFormFields();
        // this.setEvents();
    }

    initFormFields () {
        const $fields = this.$search.querySelectorAll('[' + this.settings.fieldAttr + ']');

        if ($fields.length > 0) {
            import('../form/form-input').then(({ FormInput }) => {
                for (let i = 0; i < $fields.length; i++) {
                    const $field = $fields[i];
                    const formAPI = new FormInput($field);
                    $field.API = formAPI;
                }
            });
        }
    }

    setEvents () {
    }
}

export { SearchForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $searchForms = $context.querySelectorAll('[data-searchform="root"]');

        if ($searchForms.length > 0) {
            for (let i = 0; i < $searchForms.length; i++) {
                const $searchForm = new SearchForm($searchForms[i], {
                    loader: window.OPTIONS.loader
                });
                $searchForm.initialize();
            }
        }
    }
});
